import React from 'react';

const Chevron = ({props}) => (
  <svg
    viewBox="0 0 32 32"
    aria-hidden='true'
    focusable='false'
    fill='currentColor'
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.76 25.19L.52 11a1.74 1.74 0 0 1 0-2.48l1.66-1.71a1.75 1.75 0 0 1 2.48 0L16 18.09 27.34 6.8a1.75 1.75 0 0 1 2.48 0l1.66 1.66a1.74 1.74 0 0 1 0 2.48L17.24 25.19a1.74 1.74 0 0 1-2.48 0z" />
  </svg>
);

export default Chevron;